<template>
  <div class="col-md-12">
    <div v-if="currentMember2" class="card card-container">
      <h4><font-awesome-icon icon="edit" /> Move Member to a New Sponsor</h4>
      <form name="form" @submit.prevent="moveMember2">
        <div v-if="!successful">
     
          <div class="form-group">
            <label for="networkMemberId">Network Member ID:</label>
            <input v-model="currentMember2.networkMemberId" v-validate="'required|min:9|max:12'" type="text" class="form-control" id="networkMemberId" name="networkMemberId" readonly="readonly"/>
            <div v-if="submitted && errors.has('networkMemberId')" class="alert-danger">{{errors.first('networkMemberId')}}</div>
          </div>
          <div class="form-group">
            <label for="surname">Surname:</label>
            <input v-model="currentMember2.surname" v-validate="'required|max:75'" type="text" class="form-control" id="surname" name="surname" readonly="readonly"/>
            <div v-if="submitted && errors.has('surname')" class="alert-danger" >{{errors.first('surname')}}</div>
          </div>
          <div class="form-group">
            <label for="firstName">First Name:</label>
            <input v-model="currentMember2.firstName" v-validate="'required|max:75'" type="text" class="form-control" id="firstName" name="firstName" readonly="readonly"/>
            <div v-if="submitted && errors.has('firstName')" class="alert-danger" >{{errors.first('firstName')}}</div>
          </div>
          <div class="form-group">
            <label for="middleName">Middle Name:</label>
            <input v-model="currentMember2.middleName" type="text" class="form-control" id="middleName" name="middleName" readonly="readonly"/>
            <div v-if="submitted && errors.has('middleName')" class="alert-danger" >{{errors.first('middleName')}}</div>
          </div>
          <!-- <div class="form-group">
            <label for="members2">Sponsor/Upline: </label>
            <select v-model="currentMember2.sponsor" v-validate="'required|min:9|max:12'" @change="onChangeMember2($event)" class="form-control" id="members2" name="members2">
              <option v-for="member2 in members2" v-bind:value="member2.id" :key="member2.id" :selected="member2.id === currentMember2.sponsor ? true : false">{{ member2.surname }}, {{ member2.firstName }} ({{ member2.id }})</option>
            </select>
            <div v-if="submitted && errors.has('members2')" class="alert-danger">{{errors.first('members2')}}</div>
          </div> -->
          <div class="form-group">
            <label for="sponsor">Sponsor/Upline:</label>
            <input v-model="currentMember2.sponsor" v-validate="'required|min:9|max:12'" type="number" class="form-control" id="sponsor" name="sponsor"/>
            <div v-if="submitted && errors.has('sponsor')" class="alert-danger" >{{errors.first('sponsor')}}</div>
          </div>
          
          <div class="form-group">
            <button type="submit" class="badge badge-success mr-2"><font-awesome-icon icon="save" /> Move</button>
            <button class="badge badge-primary" @click="membersList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
          </div>
        </div>
      </form>

      <div v-if="message" class="alert" :class="successful ? 'alert-success' : 'alert-danger'">
        {{message}}
      </div>
      <div v-if="message && successful">
        <button class="btn btn-primary" @click="membersList"><font-awesome-icon icon="arrow-alt-circle-left" /> Back</button>
      </div>
    </div>
    <div v-else>
      <br />
      <p>Please click on a Member...</p>
    </div>
  </div>
</template>

<script>
import MemberService from "../services/member.service";

export default {
  name: 'movemember',
  data() {
    return {
      currentMember2: null,
      submitted: false,
      successful: false,
      message: '',
      members2: [],
    };
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    }
  },
  methods: {
    getMember2(id) {
      MemberService.get(id)
        .then(response => {
          this.currentMember2 = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    retrieveMembers2() {
      MemberService.getAll()
        .then(response => {
          this.members2 = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });
    },

    onChangeMember2: function(e) {
      this.currentMember2.sponsor = e.target.value;
      //this.currentMember2.upline = this.currentMember2.sponsor;
    },
    
    /*moveMember2() {
      this.message = '';
      this.submitted = true;
      //this.currentMember.countryId = this.currentcountryId;
      this.$validator.validate().then(isValid => {
        if (isValid) {
          MemberService.moveMember(this.currentMember2.id, this.currentMember2.sponsor).then(
            response => {
              console.log(response.data);
              this.message = 'The member was moved successfully!';
              this.successful = true;
            },
            error => {
              this.message = (error.response && error.response.data) || error.message || error.toString();
              this.successful = false;
            })
            .catch(e => {
              console.log(e);
            });
        }
      });
    },*/

    moveMember2() {
      MemberService.memberExist(this.currentMember2.sponsor)
        .then(response => {
          let sponsorExistRes = response.data;
          //console.log(response.data);
          if(sponsorExistRes <= 0){
            this.message = 'Invalid Sponsor/Upline!';
            this.successful = false;
          }
          else if(this.currentMember2.sponsor >= this.currentMember2.id){
            this.message = 'Error: '+this.currentMember2.sponsor+' cannot sponsor '+this.currentMember2.id+'!';
            this.successful = false;
          }
          else{ 
            this.message = '';
            this.submitted = true;
            //this.currentMember.countryId = this.currentcountryId;
            this.$validator.validate().then(isValid => {
              if (isValid) {
                MemberService.moveMember(this.currentMember2.id, this.currentMember2.sponsor).then(
                  response => {
                    console.log(response.data);
                    this.message = 'The member was moved successfully!';
                    this.successful = true;
                  },
                  error => {
                    this.message = (error.response && error.response.data) || error.message || error.toString();
                    this.successful = false;
                  })
                  .catch(e => {
                    console.log(e);
                  });
              }
            });

          }

        })
        .catch(e => {
          console.log(e);
        });
    },

    membersList() {
      this.$router.push('/members');
    }
  },
  mounted() {
    this.message = '';
    this.getMember2(this.$route.params.id);
    //this.retrieveMembers2();
  }
};
</script>

<style scoped>
label {
  display: block;
  margin-top: 10px;
  font-size: 1.2em;
  text-align: left;
}

.card-container.card {
  max-width: 750px !important;
  padding: 40px 40px;
}

.card {
  background-color: #f7f7f7;
  padding: 20px 25px 30px;
  margin: 0 auto 25px;
  margin-top: 50px;
  -moz-border-radius: 2px;
  -webkit-border-radius: 2px;
  border-radius: 2px;
  -moz-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.3);
}

.profile-img-card {
  width: 96px;
  height: 96px;
  margin: 0 auto 10px;
  display: block;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}
</style>